import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { ExtraOptions, provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { AppSettings } from './app.settings';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { jwtInterceptor } from './interceptors/jwt.interceptor';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function tokenGetter() {
  return localStorage.getItem("auth_token");
}

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter
        },
      }),
      BrowserAnimationsModule
    ),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([jwtInterceptor])
    ),
    provideHttpClient(), provideRouter(routes, withComponentInputBinding(), withRouterConfig({paramsInheritanceStrategy: 'always'}) ), AppSettings,
    { provide: APP_INITIALIZER, useFactory: (appsettings: AppSettings) => () => appsettings.load(), deps: [AppSettings], multi: true },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE' // 'de-DE' for Germany, 'fr-FR' for France ...
    }
  ]
};
